import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const DoctorAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default DoctorAddButton;